<template>
    <div class="cp-contact-map">
        <div class="map">
            <svg width="627" height="591" viewBox="0 0 627 591" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3087_47901)">
                    <g clip-path="url(#clip1_3087_47901)">
                        <path
                            class="city"
                            v-for="vector in regions"
                            :key="vector.name"
                            :id="vector.name"
                            :d="vector.path"
                            :fill="[activeRegion, hoverRegion].includes(vector.name) ? '#FFE1D7' : 'white'"
                            :stroke="[activeRegion, hoverRegion].includes(vector.name) ? '#FF5A19' : 'black'"
                            stroke-miterlimit="10"
                            @click="show(vector.name)"
                            @mouseenter="onMapRegionHover(vector.name)"
                            @mouseleave="out()"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_3087_47901">
                        <rect width="627" height="590.575" fill="white" />
                    </clipPath>
                    <clipPath id="clip1_3087_47901">
                        <rect width="627" height="590.406" fill="white" transform="translate(0 0.516846)" />
                    </clipPath>
                </defs>
            </svg>
        </div>
        <div class="list">
            <div class="list-header">
                Przedstawiciele
            </div>
            <div class="list-items" ref="sidebar">
                <div
                    v-for="contact in contacts" :key="contact.name"
                    :class="['list-item person', {'hover': [activeRegion, hoverRegion].includes(contact.region)}]"
                    @click="show(contact.region)"
                    @mouseenter="onListItemHover(contact.region)"
                    @mouseleave="out()"
                    :ref="slugify(contact.name)"
                >
                    <img :src="contact.picture" :alt="contact.name">
                    <div class="name">{{ contact.name }}</div>
                    <div class="role">{{ contact.role }}</div>
                    <div class="cta">Więcej informacji +</div>
                </div>
            </div>

            <div class="modal" v-show="activeRegion">
                <div class="modal-body">
                    <button class="close" @click="hide()"><i class="fal fa-times"></i></button>
                    <div>
                        <div class="person" v-for="person in persons" :key="person.name">
                            <img :src="person.picture" :alt="person.name">
                            <div class="name">{{ person.name }}</div>
                            <div class="role">{{ person.role }}</div>
                            <div>
                                <a :href="'tel:' + person.phone">{{ person.phone }}</a>
                            </div>
                            <div>
                                <a :href="'mailto:' + person.email">{{ person.email }}</a>
                            </div>

                            <table class="regions" v-if="person.cities">
                                <tr v-for="cities in chunk(person.cities, 3)" :key="cities[0]">
                                    <td v-for="city in cities" :key="city">
                                        {{ city }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * Polymed only SVG Map component.
 * @see https://www.polymed.com.pl/kontakt/
 */
export default {
    props: {
        contacts: {
            default() {
                return [];
            },
            type: Array,
        },
    },

    computed: {
        persons() {
            if (this.activeRegion) {
                return this.contacts.filter((item) => item.region === this.activeRegion);
            }

            return [];
        },
    },

    data() {
        return {
            activeRegion: null,
            hoverRegion: null,
            regions: [
                {
                    name: 'ola',
                    path: 'M283.414 396.514L285.868 395.287L284.028 391.913L278.916 389.05L276.666 383.426L274.928 383.631L273.088 388.232L271.554 385.369L261.636 383.937L252.536 379.95L254.07 370.339L249.571 370.85L247.628 361.852L250.491 361.341L251.616 358.478L255.092 358.069L255.91 355.104L254.479 353.059L257.342 352.241L262.863 355.513L266.237 349.89L264.704 344.062L265.93 337.927L264.09 337.211L266.135 332.099L264.397 331.383L267.975 326.782L267.566 322.692L269.202 320.954L268.078 322.079L249.571 311.343L234.746 315.228L209.184 314.308L187.815 306.435L165.832 302.243L144.974 305.924L142.213 308.685L135.976 307.458L132.909 306.64L130.046 310.218L127.592 307.969L123.809 307.765L126.059 304.595L125.138 297.744L118.595 299.585L114.812 294.677L116.652 292.019L116.141 289.667L113.891 288.645L112.562 290.383L108.166 285.782L110.108 282.305L108.575 270.547L111.642 257.46L106.018 252.552L106.836 250.712L108.268 253.472L111.437 251.427L110.415 247.031L107.143 243.759L108.575 241.203L104.178 234.966L106.427 228.013L105.201 224.537L114.096 222.492L113.482 215.13L110.824 214.005L111.642 211.449L116.039 209.302L115.221 198.362L115.016 198.26L114.505 195.09V194.988L115.118 190.693L116.652 184.252L108.37 182.309L108.779 184.763L105.609 186.195L106.121 188.24L103.565 188.751L105.303 191L102.031 192.329L103.053 194.477L100.702 195.806L98.2478 194.579L95.5894 196.828L89.7614 193.556L81.3773 196.419L78.0032 200.305L73.4022 199.282L75.6516 205.928L60.3147 212.472L58.0653 209.916L55.407 211.756L49.9879 207.257L47.943 210.12L49.9879 212.063L46.0004 213.29L46.8183 216.357L42.7285 219.629L39.4567 231.387L37.105 232.819L32.2995 230.16L30.1523 232.001L30.2546 235.681L32.6062 239.26L30.4591 243.248L32.4017 247.235L26.9827 253.472L26.0625 257.358L29.6411 269.729L37.2073 273.512L35.1623 285.68L39.9679 290.894L37.2073 297.131L35.9803 307.356L30.6635 311.957L29.4366 315.433L32.8107 317.989L34.2421 325.044L39.7634 331.69L40.2746 337.007L36.9005 341.506L38.0252 344.675L51.8284 350.81L53.2598 361.341L57.0429 368.396L57.3496 373.202L52.6463 392.424L43.8532 410.317L54.998 410.726L54.18 405.204L56.2249 400.808L52.8508 398.559L53.8733 396.514L58.5766 395.389L62.8709 398.661L65.3248 395.696L65.427 399.07L69.6191 397.843L71.8685 399.785L72.073 408.579L77.6965 413.895L78.1055 419.621L82.1953 416.554L87.512 419.519L92.5221 419.621L98.8613 423.506L105.712 421.666L108.575 429.641L116.652 428.721L118.595 434.038L116.345 435.674L118.697 437.105L123.605 430.766L128.921 434.242L130.864 433.629L131.887 430.05L138.635 430.97L144.974 439.15L142.52 440.172L142.316 444.16L139.862 446.818L136.897 446.307L129.637 453.567L134.852 459.906L136.385 458.372L139.862 458.679L141.293 463.587L144.565 464.405L152.233 474.118L153.665 481.684L160.413 485.978L166.241 481.48L170.126 475.549L172.478 476.265L173.501 474.016L176.977 474.118L178.306 471.971L179.737 474.731L181.578 473.504L180.044 466.45L176.568 465.223L174.216 458.065L171.047 456.225L174.216 452.34L178.102 455.203L186.588 456.532L188.633 458.883L192.416 458.372L192.211 460.417L197.426 464.814L201.618 463.996L201.72 470.233L203.867 468.392L207.242 471.46L210.718 469.21L218.08 470.028L222.681 466.654L222.578 463.996L224.521 464.711L226.668 466.756L224.93 470.846L227.384 472.891L226.975 475.754L216.648 480.355L220.227 485.058L224.521 485.569L228.1 493.851L231.371 494.772L233.928 498.452L242.312 494.056L244.868 495.385L244.766 492.318L242.312 492.113L244.152 489.455L246.606 485.16L245.89 478.821L248.344 478.208L248.958 479.639L249.673 478.208L257.649 476.776H257.24L256.831 474.936L264.09 470.744L268.691 471.766L268.384 469.415L266.646 469.108L267.362 464.405L264.397 461.235L266.646 458.065L264.806 455.1L266.339 453.055L265.828 448.761L272.167 451.215L269.305 442.933L279.938 442.422L279.631 437.003L275.439 435.162L272.679 427.494L278.404 423.2L274.008 417.883L277.075 417.167L277.791 413.998L281.165 411.339L282.494 405.716L280.654 401.933L283.005 400.194L283.414 396.514Z',
                }, {
                    name: 'malgosia',
                    path: 'M457.641 56.9564L406.621 51.6396L357.747 43.9712L351.51 44.2779L346.705 52.4576L335.765 56.2406L330.346 62.6821L328.403 67.0787L327.38 66.4652L329.937 60.6372L328.301 62.2731L321.246 61.2507L321.041 57.1609L318.894 54.707L330.55 51.5373L345.376 42.642L331.368 49.5947L317.974 52.7643L304.989 53.6845L301.308 51.3329L298.445 53.48L288.22 50.5149L285.562 47.8565L287.709 47.243L281.574 46.3228L277.689 42.0285L277.382 33.8489L274.008 32.3152L276.667 33.2354L277.894 31.804L274.622 25.4647L274.826 22.0906L271.861 23.0109L271.963 16.2627L267.158 12.4796L268.896 6.14035L286.38 17.0806L293.026 27.2029L293.742 23.5221L284.233 14.8312L260.921 1.02808L239.552 1.64155L196.302 12.0706L182.908 19.0233L173.705 26.9984L162.97 29.7591L150.393 33.0309L134.136 53.071L123.707 61.3529L108.166 64.8293L86.3878 72.5999L73.5048 74.7471L42.6267 86.1986L42.5245 85.8918L38.7414 87.63L23.3023 93.049L17.5766 98.9793L10.5216 98.5703L9.49917 100.206H8.78345L8.37447 98.5703L4.38689 99.5927L6.22731 100.922L6.12507 104.501L13.8957 110.737L14.1002 110.635V108.181L17.1676 105.932L15.3272 105.625L13.8957 104.398V103.376L16.7586 101.638L19.3147 102.456L19.417 104.603L28.2101 105.932L27.4944 111.249L32.4022 101.433L32.8111 100.922L33.8336 101.024V101.433L31.3797 109.306L31.2775 114.623L28.2101 115.134L26.4719 121.473L28.5168 126.381L31.5842 126.483L30.255 132.822L24.427 125.256L18.4968 124.029L13.7935 118.201L10.9306 117.281L12.362 121.371L9.70366 121.984L10.8284 128.63L12.8733 130.471L12.2598 138.139L15.1227 143.558L18.4968 162.78L20.9507 167.484L16.5541 174.13L17.1676 180.162L14.5092 189.364L2.03525 198.771L3.0577 206.644L0.706055 211.449L6.63629 213.699L14.9182 220.447L21.9731 229.649L30.4595 235.272L30.3572 231.592L32.5044 229.751L37.3099 232.41L39.6616 230.978L42.9334 219.22L47.0233 215.948L46.2053 212.881L50.1929 211.654L48.148 209.711L50.1929 206.848L55.6119 211.347L58.2703 209.507L60.5197 212.063L75.7542 205.519L73.6071 198.873L78.2081 199.896L81.5822 196.01L89.9664 193.147L95.7944 196.419L98.4528 194.17L100.907 195.397L103.258 194.068L102.236 191.92L105.508 190.591L103.77 188.342L106.326 187.831L105.814 185.786L108.984 184.354L108.575 182.003L116.857 183.945L115.323 190.387L114.608 194.988V195.294L115.119 198.464L115.323 198.566L116.141 209.507L111.745 211.654L111.029 213.699L111.642 214.619L113.483 215.437L113.687 217.38L170.229 216.459L177.182 217.38L205.606 217.073L205.299 220.038L210.514 222.901L209.491 227.706L212.763 228.627L216.24 225.355L219.511 224.946L219.409 230.671L222.579 231.08L222.374 235.988L227.691 230.262L228.1 232.614L229.531 230.262L232.394 232.512L234.746 232.001L237.711 237.726L238.938 236.704L240.983 239.771L242.312 238.647L241.801 242.225L248.549 241.305L248.345 244.781L254.786 246.315L255.297 248.564L258.876 248.769L265.522 242.532L266.749 249.996L271.452 249.382L273.088 246.52L275.133 247.031L277.485 250.712L279.53 250.098L283.006 251.938L283.517 254.801L285.153 254.188L284.949 257.051L287.198 257.255L289.652 263.799L299.467 260.425L300.081 256.949L303.455 259.505L303.046 261.447L307.852 263.799L317.463 261.038L318.69 262.777L318.076 260.527L323.086 257.255L323.495 254.495L323.188 253.881L321.655 252.143H324.824L329.63 245.702L325.131 243.861L326.869 244.066V239.771H327.687L331.266 236.499L327.994 233.943L330.959 229.24L333.208 229.036L332.595 223.821L337.912 225.661L336.276 222.901L337.809 221.06L336.174 221.163L336.685 219.118L331.675 214.312L334.64 209.404L337.196 209.609L333.004 200.918L338.218 201.94L341.286 199.487L339.854 196.419L347.727 199.998L346.705 196.726L348.341 193.25L345.989 191.511L344.864 183.843L346.807 184.354L347.932 182.616L348.443 182.821L352.737 179.651L358.054 180.469L357.338 176.379L357.543 176.277L366.336 158.588L377.992 135.89L385.251 111.862L440.668 72.9067L458.97 57.3653L457.641 56.9564Z',
                }, {
                    name: 'asia',
                    path: 'M379.719 444.088L374.054 438.833L356.775 441.491L354.372 441.001L358.871 434.559L362.245 434.355L362.858 431.287L358.666 430.674L358.462 428.424L360.2 427.3L358.053 425.562L350.793 424.744L349.362 420.654L352.327 421.472L355.088 415.337L357.337 416.257L357.542 414.826L352.123 410.634L347.419 411.758L347.01 408.691L342 406.135L336.274 408.18L335.15 402.863L330.958 396.831L329.629 396.013L327.175 397.955L324.721 394.888L325.232 392.639L321.244 393.968L321.653 396.728L318.893 398.364L315.212 395.399L313.474 396.217L311.327 392.945L309.282 393.559L301.92 387.219L299.875 387.526L297.626 391.309L295.99 389.673L284.027 391.821L286.072 394.99L283.618 396.217L283.72 399.182L281.369 400.92L283.209 404.703L281.88 410.327L278.506 412.985L277.79 416.155L274.723 416.871L279.119 422.187L273.394 426.482L276.154 434.15L280.346 435.991L280.653 441.41L270.019 441.921L272.984 450.203L266.645 447.749L267.157 452.043L265.623 454.088L267.463 457.053L265.214 460.223L268.179 463.392L267.463 468.096L269.201 468.402L269.508 470.754L264.907 469.732L257.648 473.924L258.057 475.764H258.466L250.491 477.196L249.775 478.627L249.161 477.196L246.707 477.809L247.423 484.148L244.969 488.443L248.446 490.59L250.082 495.395L252.433 496.52L255.705 494.986L256.216 497.542L260.102 498.258L262.76 503.064L264.805 501.223L263.68 499.894L269.713 500.916L273.394 504.188L278.608 502.552L278.199 506.54L280.653 508.38L278.506 511.652L281.982 521.775L287.197 523.513L289.242 526.273L293.331 526.171L296.501 538.338L295.172 540.894L303.658 542.735L304.169 553.062H307.646L310.1 551.017L313.065 552.346L317.564 551.528L317.155 549.279L319.506 547.438L321.756 540.077L325.058 539.852L340.487 562.172L355.19 551.62L360.302 545.792L360.905 525.772L366.774 524.556L365.823 516.673L363.134 515.66L361.11 510.405V498.473L356.458 492.001V485.938L365.823 479.465L375.169 470.13C375.169 470.13 370.619 466.327 370.619 462.881C370.619 459.435 377.899 452.166 377.899 452.166L379.719 444.078V444.088Z',
                }, {
                    name: 'wiola',
                    path: 'M613.565 199.282L608.964 186.706L611.827 178.833L604.465 166.87L595.775 140.9L590.867 117.588L588.822 114.827L589.026 106.239L587.288 105.114L586.777 94.9916L584.63 90.6973L587.288 87.3232L587.493 83.6424L584.937 74.4403L575.632 63.909L569.191 62.8866L563.567 57.0586L560.193 58.7967L557.126 56.9563L558.25 53.9912L554.058 52.0485L555.081 49.9014L546.083 47.1407L544.243 47.4475L541.278 51.9463L457.641 56.9563L458.663 56.8541L440.361 72.3954L384.944 111.351L377.685 135.379L366.029 158.179L357.236 175.868L357.031 175.97L357.747 180.06L352.43 179.242L348.136 182.412L347.625 182.309L346.5 184.047L344.557 183.536L345.682 191.205L348.034 192.943L346.398 196.419L347.42 199.691L339.547 196.01L340.979 199.078L337.911 201.531L332.697 200.509L336.889 209.2L334.333 208.995L331.368 214.005L336.378 218.811L335.866 220.856L337.502 220.754L335.969 222.594L337.605 225.355L332.288 223.514L332.901 228.729L330.652 228.933L327.687 233.637L330.959 236.193L327.38 239.465H326.562V243.759L324.824 243.554L329.323 245.395L324.517 251.938H321.348L322.881 253.677L323.188 254.29L322.779 257.051L326.767 261.856L333.617 261.038L336.582 262.572L336.378 264.412L343.842 267.378L346.398 270.956L348.954 268.911L351.919 270.24L355.702 268.195L358.565 268.707L361.223 265.435L365.415 268.093L366.029 270.649L369.301 269.422L372.675 272.797L372.164 277.704L374.515 281.59L378.196 281.692L379.832 284.555L384.535 285.986L383.717 290.792L380.241 293.552L383.615 295.291L384.944 298.153L385.251 299.892L382.286 302.857L386.683 302.754L387.194 305.208L394.146 302.243L397.725 304.595L398.85 307.56L402.633 307.764L405.905 315.228L402.019 315.535L403.553 316.251L403.655 322.59L408.359 324.839V327.702L406.007 331.69L399.668 330.361L396.396 327.396L391.693 331.281L394.351 339.972L396.498 341.608L395.373 346.924L400.486 346.004L400.997 348.254L398.441 354.388L394.351 358.683L393.942 362.261L399.463 363.079L398.134 366.044L400.792 367.987L401.713 373.815L404.984 372.793L410.71 377.803L409.994 382.301L411.937 380.052L420.628 384.653L420.73 383.017L422.775 383.835L422.98 380.257L426.252 382.813L428.603 380.665L429.421 382.813L433.204 381.586L434.738 375.962L436.987 378.723L435.147 381.995L439.748 384.449L439.032 389.254L451.506 388.845L453.449 393.242L458.459 396.002L461.628 393.548L461.322 391.504L463.469 392.424L468.888 390.788L467.763 389.663L471.751 389.459L473.796 393.037L476.659 393.242L479.93 390.379L479.112 384.755L480.748 381.586L478.806 377.598L482.078 368.192L479.215 367.885L481.055 367.067L482.793 361.852L481.566 359.194L479.93 359.807L477.068 357.251L479.726 354.593L481.975 355.615L484.02 349.89L480.646 340.892L474 340.994L468.07 335.575L470.013 331.383L476.352 336.189L477.068 333.326L482.384 332.815V330.156L486.167 327.907L486.474 325.76L482.691 322.079L489.746 317.376L487.701 313.286L483.611 314.513L482.793 312.57L486.474 308.378L484.429 303.061L485.247 298.971L494.654 293.552L500.073 295.7L501.606 293.143L508.661 294.882L511.524 292.019L513.569 295.495L518.272 294.779L522.976 289.769L530.746 295.7L533.609 290.894L532.28 288.133L535.859 284.759L541.891 289.258L544.345 287.929L548.537 289.565L548.946 285.373H552.422L550.787 282.408L553.854 278.931L559.375 279.34L556.717 274.944L562.545 268.298L565.51 268.502L576.655 249.485L583.812 240.998L594.139 235.579H600.171L612.85 224.741L611.52 201.531L613.565 199.282ZM362.246 172.903L362.553 173.414L362.041 176.993L362.553 173.414L362.246 172.903Z',
                }, {
                    name: 'justyna',
                    path: 'M359.894 427.392L358.053 428.516L358.258 430.868L362.45 431.482L361.836 434.549L358.462 434.651L354.066 441.093L361.121 442.626L361.836 445.182L364.188 446L366.54 444.569L378.84 447.964L378.942 447.544L379.719 444.088L385.588 432.054L393.676 426.492L395.7 421.779L443.704 403.252L452.712 391.585L453.448 393.242L458.458 396.002L458.54 395.941L453.551 393.242L451.608 388.743L439.236 389.254L439.85 384.449L435.351 381.995L437.089 378.723L434.84 375.962L433.306 381.586L429.625 382.915L428.705 380.768L426.456 382.915L423.184 380.359L422.979 383.937L420.934 383.12L420.832 384.755L412.141 380.154L410.198 382.404L410.914 377.905L405.086 372.895L401.814 373.917L400.894 368.089L398.236 366.249L399.565 363.284L394.044 362.364L394.453 358.785L398.543 354.491L401.099 348.356L400.485 346.107L395.373 347.027L396.498 341.608L394.35 340.074L391.692 331.383L396.395 327.498L399.667 330.463L406.006 331.792L408.358 327.805V324.942L403.655 322.59L403.552 316.353L402.019 315.637L405.904 315.331L402.632 307.867L398.849 307.662L397.724 304.595L394.146 302.243L387.193 305.208L386.682 302.755L382.285 302.857L385.353 299.892L385.046 298.154L383.717 295.291L380.343 293.45L383.819 290.69L384.637 285.884L379.832 284.555L378.196 281.59L374.515 281.487L372.265 277.602L372.674 272.592L369.403 269.218L366.131 270.445L365.517 267.889L361.325 265.23L358.667 268.502L355.906 267.991L352.123 270.138L349.158 268.707L346.602 270.752L343.943 267.275L336.479 264.208L336.684 262.368L333.821 260.834L326.971 261.652L322.983 256.846L317.973 260.118L318.587 262.47L317.36 260.732L307.748 263.492L302.943 261.038L303.352 259.096L299.978 256.54L299.364 260.016L289.549 263.39L287.095 256.846L284.846 256.642L285.152 253.677L283.414 254.392L282.903 251.427L279.427 249.689L277.382 250.2L275.132 246.622L272.985 246.008L271.349 248.871L266.646 249.485L265.419 242.123L258.671 248.36L255.194 248.155L254.683 245.906L248.242 244.372L248.446 240.998L241.698 241.918L242.209 238.34L240.88 239.465L238.835 236.499L237.608 237.522L234.643 231.796L232.291 232.307L229.531 230.16L228.099 232.512L227.69 230.16L222.374 235.886L222.578 230.978L219.306 230.569L219.408 224.843L216.137 225.252L212.66 228.627L209.388 227.706L210.411 222.901L205.196 220.038L205.605 217.073L211.433 216.664L177.181 217.277L170.228 216.459L113.993 217.277H113.687L114.198 222.696L105.302 224.843L106.529 228.32L104.178 235.17L108.574 241.407L107.143 243.963L110.415 247.235L111.437 251.734L108.268 253.779L106.836 251.018L106.018 252.756L111.744 257.664L108.677 270.752L110.312 282.612L108.37 286.089L112.766 290.69L114.096 288.849L116.345 289.974L116.856 292.326L115.016 294.882L118.799 299.892L125.343 297.949L126.161 304.799L123.911 307.969L127.694 308.174L130.148 310.423L133.011 306.844L136.078 307.662L142.213 308.787L144.974 306.026L165.832 302.346L187.815 306.538L209.184 314.411L234.847 315.331L249.571 311.343L268.282 322.181L269.406 321.056L267.668 322.795L268.18 326.884L264.499 331.486L266.339 332.201L264.192 337.211L266.032 337.927L264.703 344.062L266.237 349.89L262.76 355.513L257.239 352.344L254.376 353.162L255.91 355.104L255.092 358.172L251.616 358.478L250.491 361.341L247.628 361.852L249.571 370.85L253.967 370.237L252.434 379.848L261.534 383.937L271.451 385.369L272.985 388.232L274.928 383.528L276.666 383.324L278.915 388.947L284.028 391.81L295.888 389.663L297.524 391.299L299.773 387.516L301.716 387.209L309.078 393.446L311.123 392.935L313.27 396.207L315.008 395.389L318.689 398.456L321.449 396.718L321.04 393.958L325.028 392.628L324.517 394.878L326.971 397.945L329.425 396.002L330.754 396.82L334.946 402.955L336.07 408.272L341.796 406.227L346.704 408.783L347.113 411.85L351.816 410.726L357.133 414.918L356.929 416.349L354.679 415.429L351.919 421.564L348.953 420.746L350.385 424.836L357.747 425.654L359.894 427.392Z',
                }, {
                    name: 'mawlina',
                    path: 'M623.687 413.18L626.141 410.317L620.313 408.067L615.098 402.239L614.28 398.354L611.52 396.309L612.849 395.9L611.315 390.072L608.043 387.516L608.861 382.404L600.682 376.167L598.023 368.396H594.854L594.342 364.306L597.308 360.728L598.432 355.615L595.16 352.957L595.978 348.663L593.32 347.845L592.604 344.675L589.844 344.062L588.105 333.121L589.435 327.6L587.492 324.533L594.445 317.376L592.093 313.286L592.4 309.707L593.933 310.116L594.445 308.071L592.809 305.617L594.854 303.981L593.627 302.346L597.512 298.051L594.649 291.303L595.263 289.054L591.889 285.271L588.821 285.986L585.038 281.692L585.856 278.931L581.051 279.647L579.21 276.784L567.452 274.228L567.35 269.218L565.816 268.4L565.581 268.38L565.509 268.502L562.749 268.308L557.023 274.944L559.681 279.34L559.364 279.32V279.34L554.15 278.952L551.103 282.408L552.739 285.373H549.262L548.853 289.565L548.557 289.452V289.565L544.528 288L542.207 289.258L542.075 289.166L541.901 289.258L536.042 284.882L532.596 288.133L533.926 290.894L531.063 295.7L530.848 295.536L530.756 295.7L523.159 289.902L518.589 294.779L513.885 295.495L513.865 295.454L513.579 295.495L511.646 292.213L508.978 294.882L508.732 294.82L508.671 294.882L501.882 293.205L500.389 295.7L500.144 295.597L500.082 295.7L494.847 293.624L485.563 298.971L484.746 303.061L486.79 308.378L483.11 312.57L483.897 314.431L487.711 313.286L487.752 313.368L488.017 313.286L490.062 317.376L483.11 322.079L486.893 325.76L486.586 327.907L482.803 330.156V332.815L477.486 333.326L476.77 336.189L476.423 335.933L476.361 336.189L470.329 331.608L468.488 335.575L474.408 340.984L480.656 340.892H481.065L484.439 349.89L482.394 355.615L482.046 355.452L481.985 355.615L480.012 354.716L477.476 357.251L480.216 359.695L481.566 359.194L481.627 359.327L481.975 359.194L483.202 361.852L481.463 367.067L479.623 367.885L482.486 368.192L479.316 377.598L481.259 381.586L479.991 384.04L479.459 384.091L479.112 384.766L479.93 390.389L476.658 393.252L473.795 393.047L471.75 389.469L467.763 389.673L468.887 390.798L463.468 392.434L461.321 391.514L461.628 393.559L458.458 396.013L453.448 393.252L452.712 391.596L443.704 403.252L395.7 421.778L393.675 426.492L385.588 432.054L379.719 444.088L378.942 447.544L377.899 452.176C377.899 452.176 370.619 459.456 370.619 462.891C370.619 466.327 375.169 470.141 375.169 470.141L365.824 479.476L356.458 485.948V492.011L361.11 498.483V510.415L363.135 515.67L365.824 516.683L366.775 524.566L360.906 525.783L360.303 545.802L355.19 551.63L355.497 562.059L357.235 564.206L353.759 568.296L355.088 571.773L360.303 571.977L362.143 568.807L364.801 568.398L373.492 573.715L377.48 560.73L378.298 561.753L382.081 557.151L387.909 557.867L389.136 552.141L391.487 551.732L392.612 553.368L394.248 551.835L395.168 552.857L395.066 550.914L397.622 551.119L404.166 554.902L406.722 550.914L408.665 552.55L414.39 551.119L415.617 555.516L418.787 556.742L417.969 558.072L420.423 558.992L422.161 557.765L422.774 560.321L424.615 559.708L426.251 562.468L430.034 561.446L433.204 556.129L437.089 555.107L433.817 550.812L438.316 549.483L443.53 552.653L447.62 547.029L455.186 549.585L459.992 551.426L469.91 548.154L471.546 551.119L475.431 551.528L479.623 557.049L480.134 554.8L482.895 553.573L486.78 557.458L490.461 557.663L494.858 564.104L495.88 570.034L504.673 574.124L506.82 573.306L506.923 576.169L512.648 577.805L515.716 576.987L519.09 581.281L523.895 582.508L529.417 581.486L535.347 586.905L540.868 585.576L545.674 590.381L548.332 589.87L546.798 584.246L548.332 581.384L544.549 579.952L541.993 575.556L538.925 575.453L539.948 573.204L537.698 574.942L536.983 573.92L539.437 570.034L537.392 568.603L538.925 566.967L539.334 556.129L536.267 543.553L532.688 540.077L572.462 484.864L588.821 470.754L588.699 470.703L597.308 462.881L599.966 457.36L616.836 455.11L619.086 451.839L622.767 440.387L623.176 433.128L621.131 428.936L621.642 424.846L618.268 424.539L618.575 420.449L615.098 419.529L614.689 415.644L617.245 412.985L623.687 413.19V413.18Z',
                },
            ],
        };
    },

    methods: {
        chunk(arr, len) {
            if (arr.length === 0) return [];
            return [arr.slice(0, len)].concat(this.chunk(arr.slice(len), len));
        },

        hide() {
            this.activeRegion = null;
            this.hoverRegion = null;
        },

        hover(name = null) {
            this.hoverRegion = name;

            this.setSvgRegionOnFront(name);
        },

        onClickOutside(e) {
            // @note - reset active state when clicking outside our component
            // if (!this.$el.contains(e.target)) {

            // @note - reset active state when clicking outside cities paths
            if (
                !Array.from(this.$el.querySelectorAll('.city')).filter((item) => item.contains(e.target)).length
                && !Array.from(this.$el.querySelectorAll('.list-item')).filter((item) => item.contains(e.target)).length
                && !Array.from(this.$el.querySelectorAll('.modal')).filter((item) => item.contains(e.target)).length
            ) {
                this.hide();
            }
        },

        onListItemHover(name) {
            this.hover(name);
        },

        onMapRegionHover(name) {
            this.hover(name);
            this.scrollTo(name);
        },

        out() {
            this.hoverRegion = null;

            if (this.activeRegion) {
                this.setSvgRegionOnFront(this.activeRegion);
            }
        },

        /**
         * Scroll .list to the first element with "name" as "region".
         * @param name
         */
        scrollTo(region) {
            /**
             * @param element
             * @param to
             * @param duration
             */
            const scrollTo = function (element, to, duration) {
                if (duration <= 0) {
                    return;
                }

                const difference = to - element.scrollTop;
                const perTick = difference / duration * 10;

                setTimeout(() => {
                    element.scrollTop = element.scrollTop + perTick;

                    if (element.scrollTop === to) {
                        return;
                    }

                    scrollTo(element, to, duration - 10);
                }, 10);
            }


            const contact = this.contacts.find((item) => item.region === region);

            if (contact) {
                const ref = this.slugify(contact.name);
                scrollTo(this.$refs.sidebar, this.$refs[ref][0].offsetTop - 115, 300);
            }
        },

        setSvgRegionOnFront(name) {
            // We move the selected in last position to make sure it is in front of everything
            // and have a clean hover color effect
            const index = this.regions.findIndex((item) => item.name === name);
            const item = {...this.regions[index]};
            this.regions.splice(index, 1);
            this.regions.push(item);
        },

        show(name = null) {
            this.activeRegion = name;
            this.hoverRegion = name;

            this.scrollTo(name);
        },

        slugify(text) {
            return text.toString().toLowerCase().trim()
                .replace(/&/g, '-and-')
                .replace(/[\s\W-]+/g, '-')
        },
    },

    mounted() {
        document.body.addEventListener('click', (e) => this.onClickOutside(e));
    },

    unmounted() {
        document.body.removeEventListener('click', (e) => this.onClickOutside(e));
    },
};
</script>

<style lang="scss">
@import '~bootstrap/scss/functions';
@import '../../styles/common/variables';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
@import '~bootstrap/scss/utilities';

$activeColor: #FA4700;

.cp-contact-map {
    background: #FFF4F0;
    display: flex;
    flex-direction: column;

    //@include media-breakpoint-up(md) {
    //    flex-direction: row;
    //
    //    .map {
    //        order: 2;
    //        width: 64%;
    //    }
    //
    //    .list {
    //        min-height: none;
    //        order: 1;
    //        width: 35%;
    //    }
    //}

    @include media-breakpoint-up(lg) {
        flex-direction: row;

        .map {
            order: 2;
            width: 64%;
        }

        .list {
            min-height: none;
            order: 1;
            width: 35%;
        }
    }

    .map {
        background: #FFF4F0;
        padding: 50px;

        svg {
            display: block;
            height: auto;
            margin: 0 auto;
            max-height: 100%;
            max-width: 100%;
            width: auto;

            path {
                cursor: pointer;
                transition: all .2s ease-in-out;
            }
        }
    }

    .list {
        background-color: #FFE1D7;
        min-height: 650px;
        position: relative;

        @include media-breakpoint-up(md) {
            min-width: 470px;
        }

        .list-header {
            border-bottom: 1px solid #a3a3a3;
            font-size: 45px;
            font-weight: 500;
            line-height: 120%;
            padding: 40px 40px 20px;
        }

        .list-items {
            max-height: 600px;
            overflow-y: auto;
            overflow-x: hidden;

            .list-item {
                cursor: pointer;
                margin-left: 40px;
                margin-right: 40px;
                transition: all .2s ease-in-out;

                &.hover, &:hover, &:focus {
                    img {
                        border-color: $activeColor;
                    }
                    .cta {
                        text-decoration: underline;
                    }
                }

                .name {
                    line-height: 140%;
                }

                .cta {
                    color: $activeColor;
                    font-size: 12px;
                    line-height: 16px;
                    transition: all .2s ease-in-out;
                }
            }
        }
    }

    .modal {
        background-color: rgba(0, 0, 0, .4);
        bottom: 0;
        display: flex;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: all .2s ease-in-out;
        z-index: 2;

        .modal-body {
            background-color: #fff;
            display: flex;
            font-size: 18px;
            line-height: 31px;
            margin: 40px 24px;
            overflow: hidden;
            padding: 0;
            position: relative;
            width: 100%;

            > div {
                overflow-y: auto;
                padding: 80px 24px;
                width: 100%;
            }

            a {
                text-decoration: none;
            }
        }

        .close {
            background-color: #fff;
            border: 1px solid #E8ECED;
            border-radius: 50%;
            height: 57px;
            line-height: 57px;
            position: absolute;
            right: 24px;
            text-align: center;
            top: 24px;
            transition: all .2s ease-in-out;
            width: 57px;

            &:hover, &:focus {
                background-color: #E8ECED;
            }
        }

        .person {
            .name {
                color: $activeColor;
            }
        }
    }

    .person {
        border-bottom: 1px solid #a3a3a3;
        color: #2D2D2D;
        font-family: 'DM Sans';
        font-size: 20px;
        line-height: 31px;
        padding-bottom: 24px;
        padding-top: 24px;

        &:last-child {
            border-bottom: 0;
        }

        img {
            border: 2px solid transparent;
            border-radius: 50%;
            height: 100px;
            overflow: hidden;
            transition: all .2s ease-in-out;
            width: 100px;
        }

        .name {
            font-weight: 700;
            font-size: 20px;
            line-height: 120%;
        }

        .regions {
            font-size: 16px;
            line-height: 140%;
            margin-top: 15px;
            width: 100%;
        }

        a {
            &:focus, &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
